import AccountService from "./AccountService"

import DimensionInfo from "../models/DimensionInfo"
import Dimension from "../models/Dimension"
import LocationInfo from "../models/LocationInfo"
import Location from "../models/Location"

class DimensionsService
{
    async listDimensions(options: any): Promise<DimensionInfo[]> {
        let data = await AccountService.sendRequest('LIST_DIMENSIONS', {options: options});
        return data.map((item: any)=>{return new DimensionInfo(item)});
    }

    async getDimension(env: string, id: string): Promise<Dimension> {
        let data = await AccountService.sendRequest('GET_DIMENSION', { env: env, dimension: id});
        return new Dimension(data.info);
    }

    async listDimensionFiles(env: string, dimension: string): Promise<any> {
        return AccountService.sendRequest( 'LIST_FILES', {
                env: env,
                dimension: dimension,
                options: {recursive: true,
                            directories: true,
                            files: true,
                            full_path: true,
                            extended_info: true}
            });
    }

    async createDirectory(env: string, dimension: string, directory: string): Promise<any> {
        return AccountService.sendRequest('CREATE_DIRECTORY', {
                    env: env,
                    dimension: dimension,
                    directory: directory
                });
    }

    async uploadDimensionFile(env: string, dimension: string, fileName: string, fileData: any): Promise<any> {
        return AccountService.sendRequest('SAVE_FILE', {
                    env: env,
                    dimension: dimension,
                    file_name: fileName,
                    file_data: fileData
                });
    }

    async moveFiles(env: string, dimension: string, files: string[], destination: string): Promise<any> {
        return AccountService.sendRequest('MOVE_FILES', {
                env: env,
                dimension: dimension,
                files: files,
                destination: destination
            });
    }

    async renameFile(env: string, dimension: string, source: string, target: string): Promise<any> {
        return AccountService.sendRequest('RENAME_FILE', {
                env: env,
                dimension: dimension,
                source_name: source,
                target_name: target
            });
    }

    async deleteFiles(env: string, dimension: string, files: string[]): Promise<any> {
        return AccountService.sendRequest('DELETE_FILES', {
                env: env,
                dimension: dimension,
                files: files
            });
    }

    async getFile(env: string, dimension: string, file: string): Promise<any> {
        return AccountService.sendRequest('GET_FILE', {
                env: env,
                dimension: dimension,
                file_name: file
            });
    }

    async getLocation(env: string, dimension: string, location: string): Promise<Location> {
        let data = await AccountService.sendRequest('GET_LOCATION', {
                    env: env,
                    dimension: dimension,
                    location: location
                });
        return new Location(data.info);
    }

    async getLocationClusters(env: string, dimension: string): Promise<any> {
        return AccountService.sendRequest('GET_LOCATION_CLUSTERS', {
                env: env,
                dimension: dimension
            });
    }

    async createDimension(name: string): Promise<DimensionInfo> {
        let data = await AccountService.sendRequest('CREATE_DIMENSION', {
                    config: { name: name }
                });
        return new DimensionInfo(data);
    }

    async updateDimension(env: string, dimension: string, params: any): Promise<any> {
        return AccountService.sendRequest('UPDATE_DIMENSION', {
                env: env,
                dimension: dimension,
                config: { info: params }
            });
    }

    async deleteDimension(dimension: string): Promise<any> {
        return AccountService.sendRequest('DELETE_DIMENSION', {dimension: dimension});
    }

    async publishDimension(dimension: string): Promise<any> {
        return AccountService.sendRequest('PUBLISH_DIMENSION', {dimension: dimension});
    }

    async createLocation(dimension: string, name: string, cluster: string): Promise<LocationInfo> {
        let data = await AccountService.sendRequest('CREATE_LOCATION', {
                dimension: dimension,
                config: {
                    name: name,
                    cluster: cluster ? cluster : undefined
                }
            });
        return new LocationInfo(data);
    }

    async updateLocation(env: string, dimension: string, location: string, params: any): Promise<any> {
        return AccountService.sendRequest('UPDATE_LOCATION', {
                env: env,
                dimension: dimension,
                location: location,
                config: { info: params}
            });
    }

    async deleteLocation(dimension: string, location: string): Promise<any> {
        return AccountService.sendRequest('DELETE_LOCATION', {
                dimension: dimension,
                location: location
            });
    }

    async getMapContent(env: string, dimension: string, options: any): Promise<any> {
        return AccountService.sendRequest('GET_MAP_CONTENT', {
                env: env,
                dimension: dimension,
                options: options
            });
    }

    async setUserPermissions(dimension: string, account: string, role: string): Promise<any>{
        return AccountService.sendRequest('SET_USER_PERMISSION', {
            dimension: dimension,
            permission_account: account,
            role: role
        });
    }

    async removeUserPermissions(dimension: string, account: string): Promise<any>{
        return AccountService.sendRequest('REMOVE_USER_PERMISSION', {
            dimension: dimension,
            permission_account: account
        });
    }

    async getUserPermissions(dimension: string): Promise<{ account: string, role: string }[]>{
        return AccountService.sendRequest('GET_USER_PERMISSIONS', {dimension: dimension});
    }
}

const g_dimensionsService = new DimensionsService();

export default g_dimensionsService;
